import React from "react";

export const CustomerUserDetailContext = React.createContext(null);

export const useCustomerUserDetailContext = () =>{
    const context = React.useContext(CustomerUserDetailContext);

    if(!context) throw new Error("Customer User Details Context Not Provided");

    return context
};